import { theme } from 'src/styles/theme';

import { Typography } from '..';

import { TypographyRowsContainer } from './styles';

interface TypographyRowsProps {
  textList: string[];
  shouldBoldFirstRow?: boolean;
  paddingLeft?: string;
}

export const TypographyRows = ({
  textList,
  shouldBoldFirstRow = false,
  paddingLeft = theme.space['1.0'],
}: TypographyRowsProps) => {
  return (
    <TypographyRowsContainer paddingLeft={paddingLeft}>
      {textList.map((text, index) => {
        if (index === 0 && shouldBoldFirstRow) return <Typography variant="bodyBold">{text}</Typography>;
        return <Typography variant="body">{text}</Typography>;
      })}
    </TypographyRowsContainer>
  );
};
